import { LOCALES } from 'i18n/constants';
import { setDateFNLocale } from 'i18n/date-fns';
import { getLocalesForDataCenter } from 'i18n/helpers';
import { setNumeralLocale } from './numeral';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { CURRENT_I18N_KEY, baseConfig } from 'i18n/i18n.config';
import { Locale } from 'i18n/types';

const ROOT = document.documentElement;

i18n.on('languageChanged', (lng: string) => {
  let locale: Locale | undefined = LOCALES[lng];

  // Check if it is a supported
  if (!locale) {
    const allowedLocales = getLocalesForDataCenter();
    locale = allowedLocales.find(locale => locale.languageCode === lng.toLowerCase());

    if (!locale) locale = Object.values(LOCALES).find(locale => locale.languageCode === lng.toLowerCase());

    if (locale) {
      console.warn(`The language '${lng}' is not supported. Falling back to '${locale.code}'`);

      i18n.changeLanguage(locale.code);

      return;
    }
  }

  const localeCode = locale ? locale.code : lng;

  // See https://www.i18next.com/translation-function/formatting on syncing formatting libraries with i18next
  setNumeralLocale(localeCode);
  setDateFNLocale(localeCode);

  window.localStorage.setItem(CURRENT_I18N_KEY, localeCode);
  ROOT.setAttribute('lang', localeCode);
  ROOT.setAttribute('xml:lang', localeCode);
});

// Must be below the event registration above
i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(baseConfig, (err) => {
    // tslint:disable-next-line:no-console
    if (err) console.error(`i18n Error: ${err}`);
  });

export { i18n as i18nInstance };
